var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 93,
    viewBox: "0 0 74 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 66.0996H53.1885C64.5576 66.0996 72.9998 76.521 73 88.3496C73 90.3708 71.3727 92 69.375 92C67.378 92 65.75 90.3706 65.75 88.3496C65.7498 79.6114 59.6789 73.3995 53.1885 73.3994H20.8125C14.3214 73.3994 8.25015 79.6113 8.25 88.3496C8.25 90.3707 6.6219 92 4.625 92C2.62809 92 1 90.3706 1 88.3496C1.00016 76.5208 9.44243 66.0996 20.8125 66.0996ZM36.999 1C51.7668 1 63.748 13.0391 63.748 27.9004C63.7478 42.7615 51.7667 54.7998 36.999 54.7998C22.2308 54.7998 10.2502 42.7606 10.25 27.9004C10.25 13.0385 22.2312 1.00005 36.999 1ZM36.999 8.2998C26.2244 8.29986 17.499 17.0804 17.499 27.9004C17.4993 38.7192 26.2245 47.4999 36.999 47.5C47.7727 47.5 56.4988 38.7193 56.499 27.9004C56.499 17.0804 47.7728 8.2998 36.999 8.2998Z",
    fill: "#91518D",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.b9fcb9f24dd05f97ab3f00f024a91073.svg";
export { ForwardRef as ReactComponent };